import { createSharedState } from '@ai-indeed/hooks';

export const useAnnotatedTaskId = createSharedState<number>(-1);
